import React from "react";
import "../styles/About.css"; // Reuse same CSS
import ContactSection from "../components/ContactSection/Contact"; 

const Contact = () => {
  return (
    <>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Contact Us</h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/contact">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactSection /> 
    </>
  );
};

export default Contact;
